export const Close = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className="u-icon u-icon--utility-close"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7999 3.2058C12.0743 2.93141 12.5191 2.9314 12.7935 3.20577C13.0679 3.48013 13.0679 3.92498 12.7936 4.19937L8.92801 8.06516L12.7942 11.9316C13.0686 12.206 13.0686 12.6509 12.7942 12.9252C12.5198 13.1996 12.075 13.1996 11.8006 12.9252L7.93444 9.0588L4.06828 12.9252C3.79392 13.1996 3.34907 13.1996 3.07468 12.9252C2.8003 12.6509 2.80028 12.206 3.07465 11.9316L6.94087 8.06516L3.07532 4.19937C2.80095 3.92498 2.80097 3.48013 3.07535 3.20577C3.34974 2.9314 3.79459 2.93141 4.06895 3.2058L7.93444 7.07153L11.7999 3.2058Z"
      fill="currentColor"
    />
  </svg>
);
